import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateSolicitudPagoDirecto = () => {
  const [loadingCreateSolicitudPagoDirecto, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateSolicitudPagoDirecto, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateSolicitudPagoDirecto, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateSolicitudPagoDirecto, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createSolicitudPagoDirecto = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudPagoDirectoIncapacidadTemporal(userId, data)
      .then((res: any) => {
        setLoadingCreateSolicitudPagoDirecto(false);
        setSuccessCreateSolicitudPagoDirecto(true);
        setDataSolicitudPagoDirecto(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateSolicitudPagoDirecto(false);
        setErrorCreateSolicitudPagoDirecto(err.response?.data);
      });
  };

  return {
    createSolicitudPagoDirecto,
    loadingCreateSolicitudPagoDirecto,
    successCreateSolicitudPagoDirecto,
    errorCreateSolicitudPagoDirecto,
    dataCreateSolicitudPagoDirecto
  };
};

export default useCreateSolicitudPagoDirecto;
